import React, { useState, useEffect } from 'react';
import API from '../services/api';

const AdvertisementBanner = ({ locationId }) => {
  const [currentAd, setCurrentAd] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAdvertisements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationId]);

  const loadAdvertisements = async () => {
    try {
      setLoading(true);
      const response = await API.get(`/advertisements/public/location/${locationId}`);

      if (response.data.success && response.data.data.length > 0) {
        const advertisements = response.data.data;
        // Show a random ad from the available ads
        const randomIndex = Math.floor(Math.random() * advertisements.length);
        const selectedAd = advertisements[randomIndex];
        setCurrentAd(selectedAd);

        // Track view for the selected ad
        trackView(selectedAd.id);
      }
    } catch (error) {
      console.error('Failed to load advertisements:', error);
    } finally {
      setLoading(false);
    }
  };

  const trackView = async (adId) => {
    try {
      await API.post(`/advertisements/${adId}/view`);
    } catch (error) {
      console.error('Failed to track ad view:', error);
    }
  };

  // Don't show anything if loading or no ad
  if (loading || !currentAd) {
    return null;
  }

  return (
    <div
      className="w-full bg-white rounded-lg shadow-md overflow-hidden mb-4 transition-opacity duration-500 ease-in"
      style={{ animation: 'fadeIn 0.5s ease-in' }}
    >
      {currentAd.link_url ? (
        <a
          href={currentAd.link_url}
          className="w-full block cursor-pointer hover:opacity-90 active:opacity-75 transition-opacity"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={currentAd.image_url}
            alt={currentAd.title}
            className="w-full h-auto object-cover rounded-lg"
            style={{ maxHeight: '200px' }}
            loading="lazy"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </a>
      ) : (
        <img
          src={currentAd.image_url}
          alt={currentAd.title}
          className="w-full h-auto object-cover rounded-lg"
          style={{ maxHeight: '200px' }}
          loading="lazy"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
    </div>
  );
};

export default AdvertisementBanner;
